import { atomWithReset } from "jotai/utils";

export const changePasswordOtpModalOpenAtom = atomWithReset(false);
export const changePasswordOtpExpirationTimeAtom = atomWithReset(0);
export const changePasswordFormValuesAtom = atomWithReset<{
  old_password: string;
  password: string;
  confirm_password: string;
} | null>(null);
